module.exports = __webpack_public_path__ + "static/media/medium-business-landscape.d0f9ab9e.jpg";